import { render, staticRenderFns } from "./EleFormText.vue?vue&type=template&id=8031c2c8&"
import script from "./EleFormText.vue?vue&type=script&lang=js&"
export * from "./EleFormText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports